<span *ngIf="showClose" class="motivationView_sideNavCloseButton"><button mat-button class="buttonInternal" (click)="closeSideNav()"><mat-icon>close</mat-icon></button></span>
@if(motivationDetails){
    <div class="motivationView_contentContainer" [ngStyle]="{'direction':isRTL?'rtl':'ltr'}">
        <div class="motivationView_topPart" [ngStyle]="{'background-color': motivationDetails.color}"> 
            <mat-icon class="motivationView_motivationIcon" [ngClass]="{'is-mobile-view': isMobileView}">{{motivationDetails.imageUrl}}</mat-icon>
            <span class="motivationView_motivationName" [ngClass]="{'is-mobile-view': isMobileView}" >{{motivationDetails.name}}</span>
        </div>
        @if (showVideo){
            <div class="motivationView_videoContainer">
                <iframe 
                width="560" 
                height="315" 
                [src]="motivationDetails.videoUrl | safeUrl"
                title="YouTube video player" 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen>
                </iframe>
            </div>        
        }
        <div class="textContent">           
            <span *ngFor="let currLine of descriptionTextParts" [ngClass]="{'motivationView_descriptionHeader': currLine.isHeader, 'motivationView_descriptionText' : !currLine.isHeader}">
                <br *ngIf="currLine.isHeader">
                {{currLine.text}}
                <br/>
            </span>
        </div>
    </div>
}

